export const featuredContent = [
  {
    id: 1,
    title: '星际穿越',
    category: '电影',
    rating: 9.4,
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20poster%20style%20art%2C%20space%20exploration%20with%20astronaut%20silhouette%20against%20nebula%20background%2C%20cinematic%20atmosphere%2C%20warm%20golden%20and%20deep%20indigo%20color%20scheme%2C%20dramatic%20lighting%2C%20movie%20poster%20layout%20with%20clean%20composition&width=600&height=800&seq=featured-01&orientation=portrait',
    year: 2014,
    description: '一组太空探险者穿越虫洞，为人类寻找新家园的壮丽旅程。',
  },
  {
    id: 2,
    title: '繁花',
    category: '电视剧',
    rating: 9.2,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20art%2C%201990s%20Shanghai%20street%20scene%20with%20neon%20lights%2C%20nostalgic%20atmosphere%2C%20warm%20amber%20and%20rose%20tones%2C%20elegant%20composition%2C%20cinematic%20movie%20poster%20style%20with%20soft%20focus%20background&width=600&height=800&seq=featured-02&orientation=portrait',
    year: 2023,
    description: '九十年代的上海，阿宝在时代浪潮中浮沉，书写一段传奇商业故事。',
  },
  {
    id: 3,
    title: '流浪地球2',
    category: '电影',
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20art%2C%20massive%20planet%20engine%20in%20space%2C%20epic%20scale%2C%20cool%20blue%20and%20warm%20orange%20contrast%2C%20cinematic%20lighting%2C%20grand%20composition%20with%20dramatic%20perspective&width=600&height=800&seq=featured-03&orientation=portrait',
    year: 2023,
    description: '太阳即将毁灭，人类在地球表面建造巨型推进器，开启长达2500年的流浪之旅。',
  },
  {
    id: 4,
    title: '梦华录',
    category: '电视剧',
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%20poster%2C%20Song%20Dynasty%20elegant%20scenery%20with%20traditional%20architecture%2C%20soft%20pastel%20peach%20and%20jade%20tones%2C%20graceful%20composition%2C%20cinematic%20art%20style%20with%20flowing%20fabric%20texture&width=600&height=800&seq=featured-04&orientation=portrait',
    year: 2022,
    description: '三个女人在北宋东京城经历磨难与成长，携手闯出一片天地。',
  },
  {
    id: 5,
    title: '鬼灭之刃',
    category: '动漫',
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20demon%20slayer%20poster%20art%2C%20dynamic%20sword%20action%20scene%20with%20water%20breathing%20effect%2C%20vibrant%20blue%20and%20crimson%20color%20palette%2C%20intense%20composition%2C%20anime%20illustration%20style%20with%20clean%20lines&width=600&height=800&seq=featured-05&orientation=portrait',
    year: 2019,
    description: '少年炭治郎为救妹妹踏上斩鬼之路，演绎热血与温情的传奇故事。',
  },
  {
    id: 6,
    title: '这就是街舞',
    category: '综艺',
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=Street%20dance%20competition%20show%20poster%20art%2C%20dynamic%20dancer%20silhouette%20with%20colorful%20graffiti%20background%2C%20vibrant%20neon%20pink%20and%20electric%20blue%20colors%2C%20urban%20style%2C%20energetic%20composition%20with%20motion%20effect&width=600&height=800&seq=featured-06&orientation=portrait',
    year: 2023,
    description: '顶尖舞者集结，用热血与热爱点燃舞台，展现街舞的无限魅力。',
  },
];

export const categories = [
  {
    slug: 'movies',
    name: '电影',
    icon: 'ri-movie-2-line',
    description: '院线大片 · 经典佳作',
    color: 'primary',
  },
  {
    slug: 'tv',
    name: '电视剧',
    icon: 'ri-tv-2-line',
    description: '热门剧集 · 精彩不断',
    color: 'accent',
  },
  {
    slug: 'variety',
    name: '综艺',
    icon: 'ri-emotion-laugh-line',
    description: '爆笑综艺 · 轻松一刻',
    color: 'secondary',
  },
  {
    slug: 'anime',
    name: '动漫',
    icon: 'ri-rocket-line',
    description: '热血番剧 · 二次元世界',
    color: 'primary',
  },
];

export const latestNews = [
  {
    id: 1,
    title: '2026暑期档票房突破200亿，《星际迷航：新纪元》领跑',
    excerpt: '今年暑期档电影市场空前火爆，截至8月初总票房已突破200亿元大关。由克里斯·派恩主演的科幻巨制《星际迷航：新纪元》以38.5亿的成绩暂列榜首...',
    image: 'https://readdy.ai/api/search-image?query=Cinema%20box%20office%20concept%20art%2C%20movie%20theater%20interior%20with%20warm%20golden%20lighting%2C%20film%20reel%20and%20ticket%20elements%2C%20elegant%20cinematic%20atmosphere%2C%20soft%20bokeh%20background&width=800&height=500&seq=news-01&orientation=landscape',
    date: '2026-08-10',
    author: '影视编辑',
    views: 12800,
  },
  {
    id: 2,
    title: '《长安十二时辰》续集官宣，原班人马重磅回归',
    excerpt: '备受期待的《长安十二时辰》续集《长安破晓》今日正式官宣，导演曹盾携雷佳音、易烊千玺等原班主演阵容回归，故事将延续前作的紧张节奏与宏大格局...',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20concept%20art%2C%20Tang%20Dynasty%20Changan%20cityscape%20at%20dawn%2C%20ancient%20Chinese%20architecture%20with%20warm%20morning%20light%2C%20cinematic%20atmosphere&width=800&height=500&seq=news-02&orientation=landscape',
    date: '2026-08-09',
    author: '剧集观察',
    views: 9500,
  },
  {
    id: 3,
    title: 'Netflix动画电影《深海奇缘》获奥斯卡最佳动画长片提名',
    excerpt: 'Netflix原创动画电影《深海奇缘》凭借其独特的视觉风格和动人的故事，成功入围第98届奥斯卡最佳动画长片提名名单。该片由华裔导演陈哲艺执导...',
    image: 'https://readdy.ai/api/search-image?query=Animated%20film%20deep%20ocean%20concept%20art%2C%20underwater%20fantasy%20world%20with%20bioluminescent%20creatures%2C%20vibrant%20teal%20and%20coral%20colors%2C%20dreamy%20atmosphere%2C%20animated%20movie%20aesthetic&width=800&height=500&seq=news-03&orientation=landscape',
    date: '2026-08-08',
    author: '动漫前沿',
    views: 7200,
  },
];

export const stats = [
  { value: '10万+', label: '影视资源' },
  { value: '5000万+', label: '活跃用户' },
  { value: '99.9%', label: '播放成功率' },
  { value: '4K', label: '超清画质' },
];

export const faqs = [
  {
    question: '蜜桃影视是否需要注册才能观看？',
    answer: '蜜桃影视提供免费在线观看服务，无需注册即可畅享海量影视内容。注册会员可享受更高清画质、无广告观影及专属推荐等增值服务。',
  },
  {
    question: '支持哪些设备观看蜜桃影视？',
    answer: '蜜桃影视支持多终端无缝观看，包括PC电脑、平板、手机（iOS和Android）、智能电视及投影仪等设备，只需浏览器即可访问，无需额外下载应用。',
  },
  {
    question: '蜜桃影视的视频画质如何？',
    answer: '蜜桃影视提供从流畅（480P）到超清4K的多种画质选择，根据您的网络状况自动适配最佳画质，同时支持手动切换，满足不同观影需求。',
  },
  {
    question: '影片更新频率是怎样的？',
    answer: '我们拥有专业的内容运营团队，每日更新最新影视资源。热门电影、电视剧、综艺节目和动漫番剧都会在第一时间上线，确保您不错过任何精彩内容。',
  },
  {
    question: '蜜桃影视是否有广告？',
    answer: '免费用户在观影过程中会有少量贴片广告以维持平台运营。注册VIP会员可享受全程无广告的纯净观影体验，同时解锁更多专属内容和高级功能。',
  },
];